import { TextInput } from "@datapay-by-datacom/design-system";
import type { ClientPayImportSource } from "../types/importSource";
import s from "./ImportSourceSection.module.css";

export interface ImportSourceSectionProps {
  sources: readonly ClientPayImportSource[];
  isLoading: boolean;
  loadError?: string | null;
  selectedSourceId: string | null;
  onSourceChange: (sourceId: string | null) => void;
  payPeriodLabel: string;
  onPayPeriodLabelChange: (value: string) => void;
}

export function ImportSourceSection({
  sources,
  isLoading,
  loadError = null,
  selectedSourceId,
  onSourceChange,
  payPeriodLabel,
  onPayPeriodLabelChange,
}: ImportSourceSectionProps) {
  const enabledSources = sources.filter((source) => source.enabled);

  return (
    <section className={s.section} aria-labelledby="import-source-heading">
      <h2 id="import-source-heading" className={s.heading}>
        Import source
      </h2>

      {loadError !== null && (
        <div className={s.errorBanner} role="alert">
          {loadError}
        </div>
      )}

      {isLoading ? (
        <p className={s.hint}>Loading import sources…</p>
      ) : (
        <>
          <label className={s.field}>
            <span className={s.label}>Import source type</span>
            <select
              className={s.select}
              aria-label="Import source type"
              value={selectedSourceId ?? ""}
              onChange={(event) =>
                onSourceChange(
                  event.target.value === "" ? null : event.target.value,
                )
              }
            >
              <option value="">— Select import source —</option>
              {enabledSources.map((source) => (
                <option key={source.id} value={source.id}>
                  {source.displayName}
                </option>
              ))}
            </select>
          </label>

          <div className={s.optionalField}>
            <TextInput
              label="Pay period label (optional)"
              value={payPeriodLabel}
              onChange={onPayPeriodLabelChange}
            />
            <p className={s.hint}>
              For download filename or audit — not bound to a Datapay pay run.
            </p>
          </div>
        </>
      )}
    </section>
  );
}
